module.exports = __webpack_public_path__ + "static/media/phone-tablet.17867c1.webm";


//////////////////
// WEBPACK FOOTER
// ./src/assets/home/videos/phone-tablet.webm
// module id = BXOE
// module chunks = 0